<button class="btn btn-primary">
  <input type="file" #file class="custom-file-input" (change)="selected()" />
  <em class="icon-file-picture"> </em>
</button>
